<template>
  <section>
    <institucion-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formTypeInstitucion"
      :data-edit="dataEdit"
      @refetch-data="refetchDataInstitucion"
      @error-data="showError"
    />
    <b-row class="match-height">
      <b-col
        lg="4"
        md="6"
      >
        <b-card
          class="card-transaction"
          no-body
        >
          <b-card-header>
            <b-card-title>Institución</b-card-title>

            <b-button
              v-if="userData.idInstitucion===0"
              variant="primary"
              @click="openFormInstitucion('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </b-card-header>

          <b-card-body>
            <div
              v-if="isBusyInstitucion"
              class="text-center text-primary my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
            <div style="height:715px;overflow:scroll;">
              <div
                v-for="(go, index) in itemsInstitucion"
                :key="index"
                class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                      rounded
                      size="42"
                      :variant="getClassColor(index)"
                    >
                      <feather-icon icon="GridIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="transaction-title">
                      {{ go.nombre }}
                    </h6>
                    <small>{{ go.direccion }}</small>
                  </b-media-body>
                </b-media>
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    />
                  </template>
                  <b-dropdown-item @click="getProyecto(index , 'click')">
                    <feather-icon icon="ServerIcon" />
                    <span class="align-middle ml-50">Gestionar Dependencia</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="userData.idInstitucion===0"
                    @click="getEditInstitucion(go)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Editar</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="userData.idInstitucion===0"
                    @click="getDelete(go)"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Eliminar</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="8">
        <proyecto-list
          ref="listProyectos"
          :is-get-proyecto.sync="isGetProyecto"
          :data-institucion="institucionSel"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BButton, BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem, BRow, BCol, BSpinner } from 'bootstrap-vue'
import store from '@/store'
import ProyectoList from './ProyectoList.vue'
import InstitucionForm from './InstitucionForm.vue'

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BSpinner,
    ProyectoList,
    InstitucionForm,
  },
  data() {
    return {
      classColors: ['success', 'primary', 'danger', 'warning', 'info', 'secondary'],
      itemsInstitucion: [],
      itemsM: [],
      dataEdit: {},
      isBusyInstitucion: false,
      isBusyM: false,
      formTypeInstitucion: '',
      isAddNewSidebarActive: false,
      isGetProyecto: false,
      institucionSel: {},
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async mounted() {
    await this.listarInstitucion()
    if (this.itemsInstitucion.length > 0) {
      this.getProyecto(0, 'init')
    }
  },
  methods: {
    getProyecto(index, process) {
      this.institucionSel = this.itemsInstitucion[index]
      // console.log(`go: ${this.institucionSel.idGrupoOpcion}`)
      this.isGetProyecto = true
      if (process !== 'init') { // AUTOMATICO QUITAR ESTE IF
        // this.$refs.listProyectos.listarRegistros()
      }
    },
    async listarInstitucion() {
      this.isBusyInstitucion = true
      await store
        .dispatch('gsencuesta/INSTITUCION_FIND_ALL', {
          limit: 200,
          query: '',
          page: 1,
          sortBy: 'idInstitucion%7CDESC',
        })
        .then(response => {
          this.itemsInstitucion = response.items
          this.isBusyInstitucion = false
        })
        .catch(error => {
          this.showError(error)
          this.isBusyInstitucion = false
        })
    },
    openFormInstitucion(type) {
      this.formTypeInstitucion = type
      this.isAddNewSidebarActive = true
    },
    getEditInstitucion(data) {
      this.formTypeInstitucion = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data
    },
    refetchDataInstitucion(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarInstitucion()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.message
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    getClassColor(index) {
      return this.classColors[index - 1]
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/INSTITUCION_DELETE', {
              id: data.idInstitucion,
            })
            .then(response => {
              this.listarInstitucion()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
</style>
